module.exports = __webpack_public_path__ + "img/Home3.0def4b95.png";